import {
  RETRIEVE_REFUNDS,
} from "../actions/types";
  
  const initialState = { refunds : [], totalRefundCount : 0 };

const refundReducer = (state = initialState, action) => {
  const { type, payload } = action;

  switch (type) {

    case RETRIEVE_REFUNDS:
      return {
        refunds: payload.rows,
        totalRefundCount: payload.count,
      };

    default:
      return state;
  }
};

export default refundReducer;